import * as React from "react";

const CustomExpandUp: React.FC = () => {
    return (
        <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M6.64614 0.645978C6.69259 0.599415 6.74776 0.562472 6.80851 0.537265C6.86926 0.512059 6.93438 0.499084 7.00014 0.499084C7.06591 0.499084 7.13103 0.512059 7.19178 0.537265C7.25252 0.562472 7.3077 0.599415 7.35414 0.645978L13.3541 6.64598C13.448 6.73986 13.5008 6.8672 13.5008 6.99998C13.5008 7.13275 13.448 7.26009 13.3541 7.35398C13.2603 7.44787 13.1329 7.50061 13.0001 7.50061C12.8674 7.50061 12.74 7.44787 12.6461 7.35398L7.00014 1.70698L1.35414 7.35398C1.26026 7.44787 1.13292 7.50061 1.00014 7.50061C0.867368 7.50061 0.74003 7.44787 0.646143 7.35398C0.552257 7.26009 0.499512 7.13275 0.499512 6.99998C0.499512 6.8672 0.552257 6.73986 0.646143 6.64598L6.64614 0.645978Z"
                fill="#323132"
            />
        </svg>
    );
};

export default React.memo(CustomExpandUp);
